<script setup lang="ts">
import { onMounted, defineAsyncComponent, onBeforeUnmount } from 'vue';
import i18n from '@/localization/i18n';
import { useBusinessRequestFormStore } from '@/pages/index/stores/business-request-form-store';
import { isAuth } from '@/utils/functions';
import { useUserStore } from '@/stores/user';
import {User} from "@/models/User.ts";

const businessRequestFormStore = useBusinessRequestFormStore()
const VITE_ASSET_URL = import.meta.env.VITE_ASSET_URL
const userStore = useUserStore()
const user: User = userStore.getUser

const t = i18n.global.t

let timeoutID: NodeJS.Timeout | null = null

const Close = defineAsyncComponent(() => import('vue-material-design-icons/Close.vue'))

onMounted(() => {
    timeoutID = setTimeout(() => {
        if(businessRequestFormStore.current_context === 'presentation') businessRequestFormStore.next_step('title')
  }, 5000)
})

const handleClose = () =>{
    const dismissButton: any = document.querySelector('#dismissRequestPostModal')
    if(dismissButton) dismissButton?.click()
}

const next = () => {
    if (timeoutID) clearTimeout(timeoutID)
    businessRequestFormStore.next_step('title')
}
</script>

<template>
    <div class="bg rounded main fullHeight" style="height: 550px">
        <span class="closeBtn" @click="handleClose">
            <close :size="30"></close>
        </span>
        <div class="fullHeight content mt">
            <div class="block-spacing">
                <img  height="80px" :src="VITE_ASSET_URL + 'assets/public/assets/img/presentation-logo.png'" alt="Logo topela">
            </div>
            <div class="block-spacing" >
                <div v-if="isAuth()" class="h-style h3-style white-text mb-2">
                    <p class="white-text more-text">
                        {{ t('w_txt_business_request_happy_to_see_you') }} {{ user.first_name }} !
                    </p>
                </div>
                <div  class="h-style h3-style white-text">
                    <p class="white-text">
                        {{ t('w_txt_business_request_about_project') }}
                    </p>
                </div>
            </div>
            <div>
                <button  type="button" @click="next" class="start-btn me-3 mt-2 mb-2">
                    <p class="start-text">{{ t("w_act_business_request_start") }}</p>
                </button>
            </div>
        </div>
    </div>
</template>

<style scoped>
.main {
    padding: 15px;
    position: relative;
}

.bg {
    background-color: #FEB23C !important;
}

.fullHeight {
    height: 100%;
    z-index: 1;
    display: flex;
    align-items: center; 
    justify-content: center;
    flex-direction: column;
    border: none !important;
}

.closeBtn{
    font-size: 20px;
    color: white !important;
    position: absolute;
    top: 10px;
    right: 15px;
    z-index: 2; 
    cursor: pointer;
}

.mt {
    margin-top: 10px;
}

.start-btn {
    background-color: white !important;
    padding-top: 15px;
    padding-bottom: 15px;
    border-radius: 8px;
    min-width: 160px;

    border: none;
    font-weight: bold !important;
}

.start-text {
    margin: 0px; 
    padding: 0px;
    font-size: 16px !important;
}

.white-text {
    color: rgb(243, 232, 232);
    font-size: 19px;
}

.block-spacing {
    margin-bottom: 50px;
}
</style>